import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    label: 'Discover',
    path: '/'
  }, {
    label: 'Estates',
    path: '/neighborhoods'
  }, {
    label: 'Experiences',
    path: '/experiences'
  }, {
    label: 'Plan Visit',
    path: '/plan'
  }, {
    label: 'About Nairobi',
    path: '/about-nairobi'
  }];
  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };
  return <nav className="sticky top-0 z-50 bg-transparent backdrop-blur-md border-b border-gray-200/50" data-id="element-178">
      <div className="max-w-7xl mx-auto px-8 lg:px-12" data-id="element-179">
        <div className="flex items-center justify-between h-24" data-id="element-180">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-181">
            <div className="relative" data-id="element-182">
              <div className="text-sm font-light tracking-[0.4em] text-gray-500 uppercase mb-1" data-id="element-183">
                Visit
              </div>
              <div className="text-4xl font-poppins font-normal text-gray-900 -mt-2" data-id="element-184">
                Nairobi
              </div>
              <div className="absolute -bottom-1 left-0 w-full h-px bg-gradient-to-r from-amber-600 via-amber-500 to-transparent" data-id="element-185"></div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-186">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-light tracking-wider uppercase transition-colors relative ${isActive(link.path) ? 'text-gray-900' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-187">
                {link.label}
                {isActive(link.path) && <div className="absolute -bottom-6 left-0 w-full h-px bg-amber-600" data-id="element-188"></div>}
              </Link>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-gray-900" aria-label="Toggle menu" data-id="element-189">
            {isOpen ? <X className="w-6 h-6" strokeWidth={1.5} data-id="element-190" /> : <Menu className="w-6 h-6" strokeWidth={1.5} data-id="element-191" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <div className="md:hidden py-6 border-t border-gray-200/50 bg-white/95 backdrop-blur-md" data-id="element-192">
            <div className="flex flex-col gap-6" data-id="element-193">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`text-sm font-light tracking-wider uppercase transition-colors ${isActive(link.path) ? 'text-gray-900' : 'text-gray-500'}`} data-id="element-194">
                  {link.label}
                </Link>)}
            </div>
          </div>}
      </div>
    </nav>;
}